// Packages
import { lazy, Suspense } from "react";
import { BrowserRouter, Route, Routes, Navigate } from "react-router-dom";
import { Elements } from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";
import { LoadingIcon } from "./LoadingIcon";

// Components
// import Information from "./Information";
// import Shipping from "./Shipping";
// import Billing from "./Billing";
// import Payment from "./Payment";
// import Success from "./Success";
/* eslint-disable */
const InformationPage = lazy(() => import("./Information"));
const ShippingPage = lazy(() => import("./Shipping"));
const BillingAndPaymentPage = lazy(() => import("./BillingAndPayment"));
const SuccessPage = lazy(() => import("./Success"));
const SinglePage = lazy(() => import("./SinglePage"));
/* eslint-enable */

const stripeOptions = window.stripeConnectedAccountId
  ? { stripeAccount: window.stripeConnectedAccountId }
  : {};

// Make sure to call `loadStripe` outside of a component's render to avoid
// recreating the `Stripe` object on every render.
const stripePromise = window.stripePubKey
  ? loadStripe(window.stripePubKey, stripeOptions)
  : null;

const routes = (
  <BrowserRouter>
    <Routes>
      <Route
        path="/:locale?/v2/checkout/information/:recover_token?"
        element={<InformationPage stripePromise={stripePromise} />}
      />
      <Route
        path="/:locale?/v2/checkout/shipping/:recover_token?"
        element={<ShippingPage />}
      />
      <Route
        path="/:locale?/v2/checkout/billing/:recover_token?"
        element={<BillingAndPaymentPage stripePromise={stripePromise} />}
      />
      <Route
        path="/:locale?/v2/checkout/payment/:recover_token?"
        element={<BillingAndPaymentPage stripePromise={stripePromise} />}
      />
      <Route
        path="/:locale?/v2/checkout/success/:recover_token?"
        element={<SuccessPage />}
      />
      <Route
        path="/:locale?/v2/checkout/vertical/:recover_token?"
        element={<SinglePage stripePromise={stripePromise} />}
      />
      <Route path="*" element={<Navigate to="/en/v2/checkout/information" />} />
    </Routes>
  </BrowserRouter>
);

const withStripe = (
  <Suspense fallback={<LoadingIcon default />}>
    <Elements stripe={stripePromise}>{routes}</Elements>
  </Suspense>
);

const withoutStripe = (
  <Suspense fallback={<LoadingIcon default />}>{routes}</Suspense>
);

const App = () => {
  if (stripePromise) {
    return withStripe;
  } else {
    return withoutStripe;
  }
};

export default App;
